"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(basePath, path) {
  var urlPath = basePath + '.' + (path || '');
  urlPath = urlPath.replace(/\.(\d+)/g, '[$1]').replace(/^\./, '').replace(/\.$/, '');
  return urlPath;
};